module.exports = __webpack_public_path__ + "img/wizard_hat-b.205a8f96.png";